module.exports = __webpack_public_path__ + "img/impression_gang.24dc548b.jpg";